import type { PageScrollStrategy } from './page-scroll-strategy';

export class PageNoScrollStrategy implements PageScrollStrategy {

  /** Attaches this position strategy to an overlay. */
  scroll(): void {
  }
}
